<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="ep"><span class="epub-i">It is the industry of the soul, to love and to hate; to seek after the beautiful and to recognise the ugly, to honour friends and wreak vengeance upon enemies; yet, above all, it is the work of the soul to prove it can be steadfast in these matters …</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?7bf5841a